import { render } from "./workshopChart.vue?vue&type=template&id=712f612c"
import script from "./workshopChart.vue?vue&type=script&lang=js"
export * from "./workshopChart.vue?vue&type=script&lang=js"

import "./workshopChart.vue?vue&type=style&index=0&id=712f612c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__